import Vue from 'vue';

export interface IControl {  
  //子が親に知らせる(editor.controls.push(this: IControl);)
  validator: ControlValidator;  
  isEdit:boolean;  
  enabled:boolean;
}

export interface IEditor{
  //親が子に知らせる
  addControl(control:IControl):void;
  removeControl(control:IControl):void;  
}
export interface IDirectEditProvider{
  onDirectEdit():void;
  onDirectCommit():void;  
  onDirectClose():void;  
  hasDirectPerm():boolean;
}
export class Validator  {
  public Validators: ControlValidator[] = new Array();

  public validate(): boolean {
    //全てtrueの場合にtrueを戻す
    let result = true;
    this.Validators.forEach(obj => {
      const temp = obj.validate();
      result = result && temp;
      if (temp == false) 
        console.log(String.format('validation failed for {0}', (obj.vue as any).title));
    });
    return result;
  }


}

export class ControlValidator {
  constructor(vue: Vue, tooltip: string, func: () => string) {
    this.vue = vue;
    this.tooltip = tooltip;
    this.vue.$watch('isEdit', () => this.reset());
    this.func = func;

    //this.vue.$watch('internalValue',()=>this.show());
  }
  public isValidationMode: boolean = false;
  public validateMessage: string = '';
  public vue: Vue;
  public tooltip: string;
  public func: () => string;

  public get isInvalid(): boolean {
    return this.isValidationMode && this.validateMessage != '';
  }

  public reset() {
    this.isValidationMode = false;
    this.validateMessage = '';
  }

  public update() {
    this.validateMessage = this.func();
    this.vue.$forceUpdate(); //tooltipのバインドを更新する必要がある
    if (this.vue.$refs != null) {
      if (this.isInvalid) {
        this.vue.$nextTick(() => {
          if (this.vue.$refs[this.tooltip] != null && (this.vue.$refs[this.tooltip] as any)._toolpop != null) {
            (this.vue.$refs[this.tooltip] as any)._toolpop.show();
          }
        });
      } else {
        this.vue.$nextTick(() => {
          if (this.vue.$refs[this.tooltip] != null && (this.vue.$refs[this.tooltip] as any)._toolpop != null) {
            (this.vue.$refs[this.tooltip] as any)._toolpop.hide();
          }
        });
      }
    }
  }
  public validate(): boolean {
    this.isValidationMode = true;
    this.update();
    this.vue.$forceUpdate();
    return !this.isInvalid;
  }
}


export class Editor {

  public validator: Validator = new Validator();
  public controls: IControl[] = new Array();
  public owner: IDirectEditProvider = null; //単独EditorでDirectEditProviderを実装できるようにする
  public isEdit: boolean = true;

  public addControl(control: IControl) {
    if (control.validator != null) {
      this.validator.Validators.push(control.validator);
    }
    control.isEdit = this.isEdit;
    this.controls.push(control);
  }  
  public removeControl(control: IControl){
    if (control.validator != null) {
      var index = this.validator.Validators.indexOf(control.validator);
      if (index != -1) this.validator.Validators.splice(index, 1);
    }    
    var index1 = this.controls.indexOf(control);
    if (index1 != -1) this.controls.splice(index1, 1);    
  }

  
}

//個別保存されるオブジェクト用のダミープロバイダ
export class CustomDirectEditProvider {
  public onDirectEdit() {}
  public onDirectCommit(){}
  public onDirectClose(){}
  public hasDirectPerm(){return true;}
  public isDirectEditting:boolean = false;
}